'use client'

import { useSession } from 'next-auth/react'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import EmailStep from '@components/auth/email-step'
import AuthLayout from '@layouts/auth'
import { PRIVACY_URL, TERMS_URL } from '@lib/constants'

const SignupPage = () => {
  const router = useRouter()
  const { status } = useSession()
  const googleEnabled = Boolean(process.env.NEXT_PUBLIC_GOOGLE_LOGIN_ENABLED)

  useEffect(() => {
    if (status === 'authenticated') router.replace('/onboarding')
  }, [status, router])

  return (
    <AuthLayout
      title="Create your account"
      heading="Start with OrbitID"
      subheading="Enterprise SSO and directory sync for your app."
    >
      <EmailStep googleEnabled={googleEnabled} redirect="/onboarding" cta="Sign up with email" />
      <p className="px-2 text-center text-[12.5px] leading-[18px] text-o-muted">
        By signing up, you agree to our{' '}
        <a href={TERMS_URL} className="text-o-ink underline underline-offset-2 hover:no-underline">
          Terms of Service
        </a>{' '}
        and{' '}
        <a href={PRIVACY_URL} className="text-o-ink underline underline-offset-2 hover:no-underline">
          Privacy Notice
        </a>
        .
      </p>
      <p className="pt-2 text-center text-[13.5px] text-o-muted">
        Already have an account?{' '}
        <Link href="/login" className="font-medium text-o-ink hover:underline">
          Sign in
        </Link>
      </p>
    </AuthLayout>
  )
}

export default SignupPage
